export const isValidUrl = (urlString: string): boolean => {
  try {
    const url = new URL(urlString);
    return url.protocol === 'http:' || url.protocol === 'https:';
  } catch {
    return false;
  }
};

export const isEven = (num: number): boolean => {
  const integerPart = Math.floor(num);
  return integerPart % 2 === 0;
};

export function isDecimal(value: string): boolean {
  const sanitizedValue = value.replace(',', '.');
  const parsedValue = parseFloat(sanitizedValue);

  if (isNaN(parsedValue)) {
    return false;
  }

  if (sanitizedValue.includes(',')) {
    const [, fractionalPart] = sanitizedValue.split('.');
    return fractionalPart.length > 0;
  }

  return parsedValue % 1 !== 0;
}

export const passwordValidation = (input: string): boolean => {
  const PASSWD_VALIDATION = /^(?=.*[A-Za-z])(?=.*\d).{5,}$/;
  return PASSWD_VALIDATION.test(input);
};
